module.exports = __webpack_public_path__ + "img/底花纹.c66a623b.png";